import React from 'react'
import { navigateBack } from '../../../store/history/history.actions'
import cross from '../../genericComponents/assets/cross.svg'
import SVGIcon from '../../svg/SVGIcon'
import { useAction } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import s from './CloseUserAreaButton.less'

const CloseUserAreaButton = () => {
  const execNavigateBack = useAction(navigateBack)
  const onClose = useEventCallback(execNavigateBack)

  return (
    <div className={s.closeBtn} onClick={onClose}>
      <SVGIcon url={cross} />
    </div>
  )
}

export default CloseUserAreaButton
